import { toFormat } from "@/lib/dateHelpers";
import type { SessionRegistrationRow } from "../types";

function escapeField(value: string): string {
  const sanitized = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\n]/.test(sanitized) ? `"${sanitized.replace(/"/g, '""')}"` : sanitized;
}

export function exportAttendanceList(
  eventTitle: string,
  sessions: Array<{ id: string; startsAt: string }>,
  registrations: Record<string, SessionRegistrationRow[]>
): void {
  const headers = ["Session", "PGA ID", "Registrant Name", "Attendance"];
  const rows = sessions.flatMap((session) => {
    const sessionLabel = toFormat(session.startsAt) ?? "";
    const sessionRegistrations = registrations[session.id] ?? [];
    return sessionRegistrations.map(({ attended, registration: { person } }) => [
      escapeField(sessionLabel),
      escapeField(person.pgaId),
      escapeField(person.displayName),
      attended === true ? "Present" : attended === false ? "Absent" : ""
    ]);
  });
  const csvContent = [headers.map(escapeField), ...rows].map((row) => row.join(",")).join("\n");
  const link = document.createElement("a");
  link.href = URL.createObjectURL(new Blob([csvContent], { type: "text/csv;charset=utf-8;" }));
  const slug = eventTitle
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  link.download = `${slug}-attendance-list.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}
